<template>
 <ul class="px-[10px]">
    <TransactionCard 
      v-for="value in filteredTransactions(transactions).items" 
      :key="value.id"
      :transaction="value" />
    <div v-if="getTotalCount(transactions) > maxResults" class="flex justify-end mt-[5px]">
      <a 
        @click="loadMoreResults" 
        class="max-w-fit-content px-4 py-2 text-blue-dark font-jost-semibold text-right rounded-lg hover:bg-blue-700 transition-colors duration-200 block cursor-pointer">
        Show more
      </a>
    </div>
  </ul>
</template>

<script>
import { filteredTransactions } from '@/helpers/common';
import { MAX_SEARCH_RESULTS } from '@/helpers/constants';
import TransactionCard from '@/components/common/TransactionCard.vue';
import { UiTypes } from '@/utils/uiTypes';

export default {
  name: 'TransactionsList',
  components: {
    TransactionCard,
  },
  props: {
    transactions: {
      type: Object,
      default: () => ({ items: [] })
    }
  },
  data() {
    return {
      uiTypes: UiTypes,
      maxResults: MAX_SEARCH_RESULTS,
    };
  },
  methods: {
    filteredTransactions(list) {
      return filteredTransactions(list);
    },
    getTotalCount(list) {
      if (!list) return 0;
      if (typeof list.total === 'number') return list.total;
      if (list.meta && typeof list.meta.count === 'number') return list.meta.count;
      return Array.isArray(list.items) ? list.items.length : 0;
    },
    loadMoreResults() {
      // Navigate to AllResults page with transaction type
      this.$router.push({
        name: 'resultsByType',
        params: { type: this.uiTypes.transaction },
        query: this.$route.query
      });
    }
  }
}
</script>
